import { priceTierLabel } from '@mg/shared';

const TIERS = [1, 2, 3, 4] as const;

/**
 * A value philosophy's price tier as four dollar signs, the tier's in teal and the rest in light grey,
 * so they read as a scale (spec:251). The signs are decorative: a screen reader hears "Price tier 2 of
 * 4" instead.
 */
export function PriceTier({ tier }: { tier: 1 | 2 | 3 | 4 }) {
  return (
    <span className="inline-flex shrink-0 items-center text-sm font-semibold">
      <span aria-hidden>
        {TIERS.map((n) => (
          <span key={n} className={n <= tier ? 'text-teal' : 'text-ink-ghost'}>
            $
          </span>
        ))}
      </span>
      <span className="sr-only">{priceTierLabel(tier)}</span>
    </span>
  );
}
